// Named constants to describe the different privacy category codes in OneTrust
export var PrivacyCategory = {
    StrictlyNecessary: "C0001",
    Performance: "C0002",
    Functional: "C0003",
    Targeting: "C0004",
    SocialMedia: "C0005"
};
export var PrivacyCategoryNames = Object.keys(PrivacyCategory);
export var EventNames = {
    ConsentChanged: "onetrust:consentChanged",
    Ready: "onetrust:ready"
};
export var ConsentCookieName = "OptanonConsent";
